export default __webpack_public_path__ + "static/media/ArtFlow.9b40439acf560365618016ae3005f650.webp";